import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanCreateDriver = (): boolean => {
  const [canCreateDriver, setCanCreateDriver] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const createAllPermission: Permission = {
    resource: 'drivers',
    action: 'createbasic',
    scope: 'all',
  };
  const createProviderPermission: Permission = {
    resource: 'drivers',
    action: 'createbasic',
    scope: 'provider',
  };

  const canCreateAll = useHasPermission(user, createAllPermission);
  const canCreateProvider = useHasPermission(user, createProviderPermission);

  React.useEffect(() => {
    setCanCreateDriver(canCreateAll || canCreateProvider);
  }, [canCreateAll, canCreateProvider]);

  return canCreateDriver;
};
